import { PHP_API_URL } from "../../../../util/constants";
import request from "../../../../util/request";
import Cookies from 'js-cookie';
// bot_id用户删除数据库智能体，bot_name用户更新coze智能体名称
export function getBotShareUrl(bot_id,expire_second,expire_time, callback) {
    return request(
        '/getBotShareUrl',
        {
            method: 'POST',
            body: {
                "userToken":Cookies.get("userToken"),
                "expire_second": expire_second,
                "bot_id": bot_id,
                "expire_time": expire_time,
            },
        },
        callback
    );
}
export function getBotShareListRequest(bot_id,page_num,page_size, callback) {
    return request(
        '/getBotShareList',
        {
            method: 'POST',
            body: {
                "userToken":Cookies.get("userToken"),
                "bot_id": bot_id,
                "page_num":String(page_num),
                "page_size": String(page_size),
            },
        },
        callback
    );
}
export function deleteShareBotRequest(short_code, callback) {
    return request(
        '/deleteShareBot',
        {
            method: 'POST',
            body: {
                "userToken":Cookies.get("userToken"),
                "short_code": short_code
            },
        },
        callback
    );
}
export function changeShareBotStatusRequest(short_code, status, callback) {
    return request(
        '/changeShareBotStatus',
        {
            method: 'POST',
            body: {
                "userToken":Cookies.get("userToken"),
                "short_code": short_code,
                "status": status
            },
        },
        callback
    );
}

export function changeAllShareBotStatusRequest(bot_id, status, callback) {
    return request(
        '/changeAllShareBotStatus',
        {
            method: 'POST',
            body: {
                "userToken":Cookies.get("userToken"),
                "bot_id": bot_id,
                "status": status
            },
        },
        callback
    );
}
// 改变分享智能体的过期时间
export function changeShareBotExpireTimeRequest(short_code,bot_id, expire_second, callback) {
    return request(
        '/changeShareBotExpireTime',
        {
            method: 'POST',
            body: {
                "userToken":Cookies.get("userToken"),
                "bot_id": bot_id,
                "short_code": short_code,
                "expire_second": expire_second
            },
        },
        callback
    );
}

